export default () => ({
  knowledgeId: null,
  timeout: null,
  isGenerating: false,
  timeoutTime: 500,
  link: null
});
